(function () {
    var globalKey = '__productRecommendationsSwiper';

    if (window[globalKey]) {
        window[globalKey].initAll(document);
        return;
    }

    var swiperScriptPromise;

    function ensureSwiper() {
        if (window.Swiper) {
            return Promise.resolve(window.Swiper);
        }

        if (swiperScriptPromise) {
            return swiperScriptPromise;
        }

        swiperScriptPromise = new Promise(function (resolve, reject) {
            var existingScript = document.getElementById('product-recommendations-swiper-script');

            function resolveSwiper() {
                if (window.Swiper) {
                    resolve(window.Swiper);
                    return;
                }

                reject(new Error('Swiper did not initialize.'));
            }

            function rejectSwiper() {
                reject(new Error('Failed to load Swiper.'));
            }

            if (existingScript) {
                if (existingScript.dataset.loaded === 'true') {
                    resolveSwiper();
                    return;
                }

                existingScript.addEventListener('load', resolveSwiper, { once: true });
                existingScript.addEventListener('error', rejectSwiper, { once: true });
                return;
            }

            var script = document.createElement('script');
            script.id = 'product-recommendations-swiper-script';
            script.src = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';
            script.async = true;
            script.addEventListener(
                'load',
                function () {
                    script.dataset.loaded = 'true';
                    resolveSwiper();
                },
                { once: true }
            );
            script.addEventListener('error', rejectSwiper, { once: true });
            document.head.appendChild(script);
        });

        return swiperScriptPromise;
    }

    function escapeHtml(value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            const moneyFormat = window.Shopify.money_format || window.Shopify.moneyFormat;
            if (moneyFormat) return window.Shopify.formatMoney(cents, moneyFormat);
        }
        return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }

    function getProductImage(product) {
        return product && product.featured_image ? product.featured_image : '';
    }

    function getDesktopSlidesPerView(productCount) {
        if (productCount > 4) {
            return 4;
        }

        if (productCount > 1) {
            return productCount - 1;
        }

        return 1;
    }

    function normalizeImageSrc(src) {
        return src ? String(src).replace(/^https?:/, '').split('?')[0] : '';
    }

    /*
      Cards show product.featured_image but were priced from product.price, which is
      the MINIMUM across every variant. On a product with one discounted colour that
      advertises a price — and a strikethrough — belonging to a colour that is not
      pictured, and which may be nearly sold out. Price from the variant that owns
      the image actually on screen, falling back to the first available variant.
    */
    function getCardVariant(product) {
        var variants = (product && product.variants) || [];
        var shown = normalizeImageSrc(getProductImage(product));
        var i;

        if (shown) {
            for (i = 0; i < variants.length; i++) {
                var variantImage = variants[i].featured_image;
                if (variantImage && normalizeImageSrc(variantImage.src) === shown) {
                    return variants[i];
                }
            }
        }

        for (i = 0; i < variants.length; i++) {
            if (variants[i].available) {
                return variants[i];
            }
        }

        return variants[0] || product;
    }

    function createRecommendationCard(product) {
        var item = document.createElement('article');
        item.className = 'product-recommendations__item swiper-slide';

        var imageUrl = getProductImage(product);
        var productTitle = escapeHtml(product.title);
        var productUrl = product.url;

        var cardVariant = getCardVariant(product);

        var comparePriceHtml = '';
        if (cardVariant.compare_at_price && cardVariant.compare_at_price > cardVariant.price) {
            comparePriceHtml =
                '<span class="product-recommendations__compare-price">' + formatMoney(cardVariant.compare_at_price) + '</span>';
        }

        item.innerHTML =
            '' +
            '<a class="product-recommendations__card" href="' +
            productUrl +
            '">' +
            '<div class="product-recommendations__image-wrap">' +
            (imageUrl
                ? '<img class="product-recommendations__image" src="' +
                imageUrl +
                '" alt="' +
                productTitle +
                '" loading="lazy" width="400" height="400">'
                : '') +
            '</div>' +
            '<div class="product-recommendations__content">' +
            '<h3 class="product-recommendations__product-title">' +
            productTitle +
            '</h3>' +
            '<div class="product-recommendations__price-row">' +
            '<span class="product-recommendations__price">' +
            formatMoney(cardVariant.price) +
            '</span>' +
            comparePriceHtml +
            '</div>' +
            '</div>' +
            '</a>';

        return item;
    }

    function renderRecommendations(section, products) {
        var track = section.querySelector('.product-recommendations__track');

        if (!track) {
            return false;
        }

        track.innerHTML = '';

        if (!Array.isArray(products) || products.length === 0) {
            section.style.display = 'none';
            return false;
        }

        products.forEach(function (product) {
            track.appendChild(createRecommendationCard(product));
        });

        return true;
    }

    function initializeSwiper(section, productCount) {
        var viewport = section.querySelector('.product-recommendations__viewport');
        var prevButton = section.querySelector('.product-recommendations__nav--prev');
        var nextButton = section.querySelector('.product-recommendations__nav--next');

        if (!viewport || !prevButton || !nextButton || !window.Swiper) {
            return;
        }

        if (section.productRecommendationsSwiper) {
            section.productRecommendationsSwiper.destroy(true, true);
        }

        prevButton.classList.remove('is-hidden');
        nextButton.classList.remove('is-hidden');

        section.productRecommendationsSwiper = new window.Swiper(viewport, {
            loop: productCount > 1,
            speed: 500,
            spaceBetween: 12,
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            watchSlidesProgress: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
                pageUpDown: true,
            },
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
                lockClass: 'is-hidden',
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Show previous recommended products',
                nextSlideMessage: 'Show next recommended products',
                slideLabelMessage: '{{index}} of {{slidesLength}}',
                itemRoleDescriptionMessage: 'slide',
            },
            breakpoints: {
                750: {
                    slidesPerView: getDesktopSlidesPerView(productCount),
                    slidesPerGroup: 4,
                },
            },
        });

        updateSlidesAccessibility(section.productRecommendationsSwiper);
        section.productRecommendationsSwiper.on('realIndexChange', () => {
            updateSlidesAccessibility(section.productRecommendationsSwiper);
        });
    }

    function updateSlidesAccessibility(swiper) {
        let swiperSlides = swiper.slides;

        // get the slide that is active
        let activeIndex = swiper.activeIndex;

        // get the value of currently how many slides are there to show
        let slidesPerView = Math.ceil(swiper.params.slidesPerView);

        // get in an array the active slide and the next siblings calculated by the amount of slides to show
        let visibleSlides = [];

        for (let i = 0; i < slidesPerView; i++) {
            let slide = swiperSlides[activeIndex + i];
            if (slide) {
                visibleSlides.push(slide);
            }
        }

        // ADA only make the visible slides focusable
        swiperSlides.forEach((slide) => {
            let isSlideVisible = visibleSlides.includes(slide);
            let slideLinks = slide.querySelectorAll('a');

            slideLinks.forEach((link) => {
                if (isSlideVisible) {
                    link.removeAttribute('tabindex');
                    link.removeAttribute('aria-hidden');
                } else {
                    link.setAttribute('tabindex', '-1');
                    link.setAttribute('aria-hidden', 'true');
                }
            });
        });
    }

    function fetchRecommendations(productId, limit, intent) {
        var endpoint = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit) + '&intent=' + encodeURIComponent(intent);

        return fetch(endpoint)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Failed to fetch recommendations.');
                }

                return response.json();
            })
            .then(function (data) {
                return data.products || [];
            });
    }

    function initializeRecommendationSection(section) {
        if (!section || section.dataset.initialized === 'true') return;

        var productId = section.dataset.productId;

        if (!productId) return;

        var limit = parseInt(section.dataset.limit, 10) || 8;
        var intent = section.dataset.intent || 'related';

        section.dataset.initialized = 'true';

        Promise.all([ensureSwiper(), fetchRecommendations(productId, limit, intent)])
            .then(function (results) {
                var products = results[1];

                section.removeAttribute('aria-busy');

                if (!renderRecommendations(section, products)) {
                    return;
                }

                initializeSwiper(section, products.length);
            })
            .catch(function (error) {
                console.error('Recommendation slider error:', error);
                section.removeAttribute('aria-busy');
                section.style.display = 'none';
            });
    }

    function getSections(root) {
        if (!root) {
            return [];
        }

        if (root.nodeType === 1 && root.matches('.product-recommendations[data-product-id]')) {
            return [root];
        }

        if (root.querySelectorAll) {
            return root.querySelectorAll('.product-recommendations[data-product-id]');
        }

        return [];
    }

    function initializeAllRecommendationSections(root) {
        var sections = getSections(root || document);

        Array.prototype.forEach.call(sections, function (section) {
            initializeRecommendationSection(section);
        });
    }

    window[globalKey] = {
        initAll: initializeAllRecommendationSections,
    };

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            function () {
                initializeAllRecommendationSections(document);
            },
            { once: true }
        );
    } else {
        initializeAllRecommendationSections(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
        initializeAllRecommendationSections(event.target);
    });
})();